module.exports = __webpack_public_path__ + "img/china-flag.bcee596.png";